import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.BillBatchPaymentRequestCard.BillsInformationSection', {
    headerText: 'XERO BATCH PAYMENT BILLS',
    total: 'TOTAL:',
});
